export default function (context, val) {
    let setting = context.rootState.settings.paymentItems;
    let items = context.state.list.items;
    // debugger
    if(items.length){
        if(setting.search){
            context.commit('list/clean');
            context.dispatch('search');
            context.state.details = !!val;
            return;
        }
        if(context.state.details !== val){
            context.commit('list/clean');
            context.state.details = !!val;
            context.dispatch('search');
            return;
        }
        return;
    }
    context.state.details = !!val;
    let filter;
    if (setting.defaultFilter) {
        filter = setting.filters.filter(i => {
            return i.id === setting.defaultFilter;
        })[0];
    }else{
        filter = setting.filters[0];
    }
    if (filter) {
        context.dispatch('form/filter', filter);
    }
}